/**
 * @flow
 * @relayHash c9146735209a01de7265b500f870e1a4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CheckoutPage_viewer$ref = any;
export type CheckoutPageQueryRendererQueryVariables = {|
  isLoggedIn?: ?boolean,
  noAdyenRedirectResult?: ?boolean,
  adyenRedirectResult?: ?string,
|};
export type CheckoutPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CheckoutPage_viewer$ref
  |}
|};
export type CheckoutPageQueryRendererQuery = {|
  variables: CheckoutPageQueryRendererQueryVariables,
  response: CheckoutPageQueryRendererQueryResponse,
|};
*/


/*
query CheckoutPageQueryRendererQuery(
  $isLoggedIn: Boolean
  $noAdyenRedirectResult: Boolean
  $adyenRedirectResult: String
) {
  viewer {
    ...CheckoutPage_viewer
    id
  }
}

fragment CartBillItem_billItem on BillItem {
  bruttoPrice
  discount
  lineItem {
    ...CartLineItem_lineItem
    id
  }
  price
  vat
}

fragment CartLineItemFotoFlat_lineItem on LineItem {
  media {
    mediaList(first: 50) {
      edges {
        node {
          variants {
            name
            url
            id
          }
          id
        }
      }
    }
  }
  product {
    event {
      name
      mainSearch
      id
    }
    id
  }
  productParams {
    __typename
    ... on FotoFlatParams {
      startnumber
    }
  }
}

fragment CartLineItemSinglePhoto_lineItem on LineItem {
  product {
    event {
      name
      id
    }
    id
  }
  productParams {
    __typename
    ... on SingleFotoParams {
      foto {
        sgId
        variants {
          name
          url
          id
        }
        id
      }
    }
  }
}

fragment CartLineItem_lineItem on LineItem {
  product {
    type
    id
  }
  ...CartLineItemFotoFlat_lineItem
  ...CartLineItemSinglePhoto_lineItem
}

fragment CheckoutBillTable_bill on Bill {
  charges
  items {
    id
    lineItem {
      product {
        type
        id
      }
      id
    }
    ...CartBillItem_billItem
  }
  coupon {
    vat
    brutto
    code
  }
  totalBruttoPrice
  totalBruttoPriceUnpayed
  totalNettoPrice
}

fragment CheckoutOrderingAddressStep_cart on Cart {
  id
  customer {
    email
    id
  }
  order {
    id
    address {
      firstName
      lastName
      phone
      city
      postalCode
      line2
      line1
      country {
        alpha2
        name
        id
      }
      state
      id
    }
  }
}

fragment CheckoutOrderingAddressStep_viewer on Viewer {
  countries {
    name
    alpha2
    id
  }
  account @include(if: $isLoggedIn) {
    profile {
      addresses(first: 10) {
        edges {
          node {
            firstName
            lastName
            phone
            city
            postalCode
            state
            line2
            line1
            country {
              alpha2
              name
              id
            }
            id
          }
        }
      }
      email
      id
    }
    id
  }
}

fragment CheckoutOrderingPaymentStepAddress_address on Address {
  firstName
  lastName
  phone
  city
  state
  postalCode
  line2
  line1
  country {
    alpha2
    name
    id
  }
}

fragment CheckoutOrderingPaymentStep_cart on Cart {
  id
  availablePaymentMethods {
    id
    name
    defaultPaymentType
  }
  order {
    id
    address {
      firstName
      lastName
      line1
      line2
      postalCode
      city
      country {
        alpha2
        id
      }
      state
      ...CheckoutOrderingPaymentStepAddress_address
      id
    }
    bill {
      totalBruttoPrice
      totalBruttoPriceUnpayed
      ...CheckoutBillTable_bill
    }
    payment {
      paymentMethod {
        id
        name
        defaultPaymentType
      }
      id
    }
    state
  }
  additionalProducts {
    id
    type
  }
  paymentRequired
  totalPrice
}

fragment CheckoutOrderingSteps_cart on Cart {
  id
  customer {
    email
    id
  }
  lineItems {
    id
    product {
      eventId
      id
    }
  }
  order {
    id
    state
    orderid
  }
  shipmentRequired
  paymentRequired
  totalPrice
  availablePaymentMethods {
    id
    name
    defaultPaymentType
  }
  ...CheckoutOrderingAddressStep_cart
  ...CheckoutOrderingPaymentStep_cart
}

fragment CheckoutOrderingSteps_viewer on Viewer {
  ...CheckoutOrderingAddressStep_viewer
}

fragment CheckoutPage_viewer on Viewer {
  cart {
    lineItems {
      id
      product {
        id
        event {
          id
          sgId
          name
        }
      }
    }
    customer {
      email
      id
    }
    id
    order {
      id
      orderid
    }
    ...CheckoutOrderingSteps_cart
  }
  adyenPaymentsDetails(redirectResult: $adyenRedirectResult) @skip(if: $noAdyenRedirectResult) {
    merchantReference
    pspReference
    resultCode
  }
  ...CheckoutOrderingSteps_viewer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isLoggedIn",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "noAdyenRedirectResult",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "adyenRedirectResult",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "postalCode",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line2",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line1",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alpha2",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "country",
  "storageKey": null,
  "args": null,
  "concreteType": "Country",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v3/*: any*/),
    (v1/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variants",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaFile",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    (v1/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vat",
  "args": null,
  "storageKey": null
},
v18 = [
  (v1/*: any*/),
  (v3/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "defaultPaymentType",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CheckoutPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CheckoutPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CheckoutPageQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventId",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v1/*: any*/)
                ]
              },
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderid",
                    "args": null,
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v5/*: any*/),
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bill",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Bill",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalBruttoPrice",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalBruttoPriceUnpayed",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "charges",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BillItem",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "lineItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LineItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "product",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "event",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "mainSearch",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v1/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "media",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ExtendedMediaConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mediaList",
                                    "storageKey": "mediaList(first:50)",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 50
                                      }
                                    ],
                                    "concreteType": "MediaConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "MediaEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Media",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "productParams",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "FotoFlatParams",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "startnumber",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "SingleFotoParams",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "foto",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Media",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v16/*: any*/),
                                          (v1/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "bruttoPrice",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "discount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price",
                            "args": null,
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "coupon",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BillCoupon",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "brutto",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "code",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalNettoPrice",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Payment",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paymentMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": false,
                        "selections": (v18/*: any*/)
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shipmentRequired",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "paymentRequired",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "availablePaymentMethods",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethod",
                "plural": true,
                "selections": (v18/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "additionalProducts",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v15/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "countries",
            "storageKey": null,
            "args": null,
            "concreteType": "Country",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v13/*: any*/),
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "noAdyenRedirectResult",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "adyenPaymentsDetails",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "redirectResult",
                    "variableName": "adyenRedirectResult"
                  }
                ],
                "concreteType": "AdyenPaymentsDetails",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "merchantReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pspReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "resultCode",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isLoggedIn",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "account",
                "storageKey": null,
                "args": null,
                "concreteType": "Account",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "addresses",
                        "storageKey": "addresses(first:10)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 10
                          }
                        ],
                        "concreteType": "AddressConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AddressEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Address",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v14/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CheckoutPageQueryRendererQuery",
    "id": null,
    "text": "query CheckoutPageQueryRendererQuery(\n  $isLoggedIn: Boolean\n  $noAdyenRedirectResult: Boolean\n  $adyenRedirectResult: String\n) {\n  viewer {\n    ...CheckoutPage_viewer\n    id\n  }\n}\n\nfragment CartBillItem_billItem on BillItem {\n  bruttoPrice\n  discount\n  lineItem {\n    ...CartLineItem_lineItem\n    id\n  }\n  price\n  vat\n}\n\nfragment CartLineItemFotoFlat_lineItem on LineItem {\n  media {\n    mediaList(first: 50) {\n      edges {\n        node {\n          variants {\n            name\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  product {\n    event {\n      name\n      mainSearch\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on FotoFlatParams {\n      startnumber\n    }\n  }\n}\n\nfragment CartLineItemSinglePhoto_lineItem on LineItem {\n  product {\n    event {\n      name\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on SingleFotoParams {\n      foto {\n        sgId\n        variants {\n          name\n          url\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CartLineItem_lineItem on LineItem {\n  product {\n    type\n    id\n  }\n  ...CartLineItemFotoFlat_lineItem\n  ...CartLineItemSinglePhoto_lineItem\n}\n\nfragment CheckoutBillTable_bill on Bill {\n  charges\n  items {\n    id\n    lineItem {\n      product {\n        type\n        id\n      }\n      id\n    }\n    ...CartBillItem_billItem\n  }\n  coupon {\n    vat\n    brutto\n    code\n  }\n  totalBruttoPrice\n  totalBruttoPriceUnpayed\n  totalNettoPrice\n}\n\nfragment CheckoutOrderingAddressStep_cart on Cart {\n  id\n  customer {\n    email\n    id\n  }\n  order {\n    id\n    address {\n      firstName\n      lastName\n      phone\n      city\n      postalCode\n      line2\n      line1\n      country {\n        alpha2\n        name\n        id\n      }\n      state\n      id\n    }\n  }\n}\n\nfragment CheckoutOrderingAddressStep_viewer on Viewer {\n  countries {\n    name\n    alpha2\n    id\n  }\n  account @include(if: $isLoggedIn) {\n    profile {\n      addresses(first: 10) {\n        edges {\n          node {\n            firstName\n            lastName\n            phone\n            city\n            postalCode\n            state\n            line2\n            line1\n            country {\n              alpha2\n              name\n              id\n            }\n            id\n          }\n        }\n      }\n      email\n      id\n    }\n    id\n  }\n}\n\nfragment CheckoutOrderingPaymentStepAddress_address on Address {\n  firstName\n  lastName\n  phone\n  city\n  state\n  postalCode\n  line2\n  line1\n  country {\n    alpha2\n    name\n    id\n  }\n}\n\nfragment CheckoutOrderingPaymentStep_cart on Cart {\n  id\n  availablePaymentMethods {\n    id\n    name\n    defaultPaymentType\n  }\n  order {\n    id\n    address {\n      firstName\n      lastName\n      line1\n      line2\n      postalCode\n      city\n      country {\n        alpha2\n        id\n      }\n      state\n      ...CheckoutOrderingPaymentStepAddress_address\n      id\n    }\n    bill {\n      totalBruttoPrice\n      totalBruttoPriceUnpayed\n      ...CheckoutBillTable_bill\n    }\n    payment {\n      paymentMethod {\n        id\n        name\n        defaultPaymentType\n      }\n      id\n    }\n    state\n  }\n  additionalProducts {\n    id\n    type\n  }\n  paymentRequired\n  totalPrice\n}\n\nfragment CheckoutOrderingSteps_cart on Cart {\n  id\n  customer {\n    email\n    id\n  }\n  lineItems {\n    id\n    product {\n      eventId\n      id\n    }\n  }\n  order {\n    id\n    state\n    orderid\n  }\n  shipmentRequired\n  paymentRequired\n  totalPrice\n  availablePaymentMethods {\n    id\n    name\n    defaultPaymentType\n  }\n  ...CheckoutOrderingAddressStep_cart\n  ...CheckoutOrderingPaymentStep_cart\n}\n\nfragment CheckoutOrderingSteps_viewer on Viewer {\n  ...CheckoutOrderingAddressStep_viewer\n}\n\nfragment CheckoutPage_viewer on Viewer {\n  cart {\n    lineItems {\n      id\n      product {\n        id\n        event {\n          id\n          sgId\n          name\n        }\n      }\n    }\n    customer {\n      email\n      id\n    }\n    id\n    order {\n      id\n      orderid\n    }\n    ...CheckoutOrderingSteps_cart\n  }\n  adyenPaymentsDetails(redirectResult: $adyenRedirectResult) @skip(if: $noAdyenRedirectResult) {\n    merchantReference\n    pspReference\n    resultCode\n  }\n  ...CheckoutOrderingSteps_viewer\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50353f6beee435ec3d359fbf4d7ed8b6';

module.exports = node;
